import React from 'react';
import { useScope } from '../scopeContext';
import ProjectSelect from './ProjectSelect';

const ProjectPicker: React.FC = () => {
  const { scope, setScope } = useScope();
  return (
    <div style={{ marginBottom: 12 }}>
      <ProjectSelect
        value={scope.project_id}
        onChange={(id) => setScope({ project_id: id })}
        allowNull
      />
    </div>
  );
};

export default ProjectPicker;
